<template>
  <v-app>
    <PlanoDeFundo />
    <v-main>
      <BioDoArtista />
    </v-main>
    <RodapeInfo />
  </v-app>
</template>

<script>
import PlanoDeFundo from "./components/PlanoDeFundo.vue";
import BioDoArtista from "./components/BioDoArtista.vue";
import RodapeInfo from "./components/RodapeInfo.vue";

export default {
  name: "App",
  components: {
    PlanoDeFundo,
    BioDoArtista,
    RodapeInfo,
  },
};
</script>

<style>
/* Layout Global */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  width: 100%;
  height: 100%;
  font-family: "Roboto", Arial, sans-serif;
  scroll-behavior: smooth;
}

#app {
  overflow-x: hidden;
}

.content {
  z-index: 1;
  position: relative;
}
</style>
